// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_GatewaySettingsInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_GatewaySettingsInput — body for:
 *   POST /subscriptions/gateways/settings       (provider_code + setting_key + setting_value)
 *   POST /subscriptions/gateways/rotate-secret   (provider_code only)
 *
 * setting_key/setting_value are optional at the contract level so the same
 * input class serves both endpoints: rotate-secret only reads provider_code
 * and ignores the other two. The settings-write path enforces setting_key
 * presence itself (see Gateways::settings()).
 *
 * provider_code must be a REGISTERED gateway (PlatformGatewayRegistry) —
 * both write endpoints share this check (M11).
 *
 * setting_key, when present, must be one of ALLOWED_SETTING_KEYS. This blocks
 * writing webhook_secret through this endpoint: masked-GET-only means a caller
 * could otherwise overwrite it with a known value and effectively read it
 * back via the write they control (M11). Rotate the secret instead.
 *
 * 'auto_confirm' was removed from the allowlist on 2026-07-29: no code has read
 * it since M8 cut its one behaviour, so accepting the write meant persisting a
 * value that moved nothing while the staff console showed the operator a live
 * toggle. A key with no reader is not writable — see
 * Payment_gateway_settings_model::RETIRED_KEYS.
 */
import { registerContract } from './validate'

export interface Subscriptions_GatewaySettingsInput {
provider_code: string
setting_key?: string
setting_value?: string
}

registerContract('Subscriptions_GatewaySettingsInput', {
  provider_code: { type: 'string',  required: true },
  setting_key:   { type: 'string',  required: false },
  setting_value: { type: 'string',  required: false },
})
